/**
 * True if `value` is a non-empty run of ASCII digits — the canonical shape of a
 * bigint PK / seq cursor carried as a decimal string across the wire.
 *
 * Single source of truth for the `/^\d+$/` check used by the domain-event
 * schema (frame `id` + feed `latestSeq`) and the session seq cursor
 * (`domainEventCursor`), so the three former copies can't drift apart.
 */
export const isNumericIdString = (value: string): boolean =>
  /^\d+$/.test(value);
